import apiClient from './apiClient'


const getEvents = (tenant, projectId) => {
  return apiClient.get(`/${tenant}/Event/${projectId}`)
}

const getEventById = (tenant, projectId, eventId) => {
  return apiClient.get(`/${tenant}/Event/${projectId}/${eventId}`)
}

const getRelations = (tenant, eventId) => {
  return apiClient.get(`/${tenant}/Event/${eventId}/Relations`)
}

const createEvent = (tenant, projectId, event) => {
  return apiClient.post(`/${tenant}/Event/${projectId}`, event)
}

const updateEvent = (tenant, projectId, eventId, event) => {
  return apiClient.put(`/${tenant}/Event/${projectId}/${eventId}`, event)
}

const deleteEvent = (tenant, projectId, eventId) => {
  return apiClient.delete(`/${tenant}/Event/${projectId}/${eventId}`)
}


export default {
  getEvents,
  getEventById,
  getRelations,
  createEvent,
  updateEvent,
  deleteEvent
}
